export { VpDocViewer } from './VpDocViewer';



// WEBPACK FOOTER //
// ./src/vp-ui/components/VpDocViewer/index.js